import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { TipoRol } from '@rpe/registro-personas-empresas-lib';
import { select, Store } from '@ngrx/store';

import { AppState } from 'projects/registro-personas-empresas/src/app/core/core.state';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import { VinculoLaboralSeccionFormInput } from '../vinculo-laboral-seccion/vinculo-laboral-seccion.interface';

import { ROUTE_ANIMATIONS_ELEMENTS } from 'projects/registro-personas-empresas/src/app/core/core.module';
import { selectAllEntidadesProductiva } from '../../../../empresas/entity-entidad-productiva/entity-entidades-productiva.selectors';
import { PersonasFisica } from '../../../../empresas/entity-personas-fisica/entity-personas-fisica.model';
import { selectAllPersonasFisica } from '../../../../empresas/entity-personas-fisica/entity-personas-fisica.selectors';
import { PersonasJuridica } from '../../../../empresas/entity-personas-juridica/entity-personas-juridica.model';
import { selectAllPersonasJuridica } from '../../../../empresas/entity-personas-juridica/entity-personas-juridica.selectors';
import { selectAllTiposRol } from '../../../entity-tipos-rol/entity-tipos-rol.selectors';
import {
  selectAuthPersona,
  selectAllPersonas
} from '../../../../persona/entity-personas/entity-personas.selectors';
import { TecnicoResponsable } from '../../../entity-tecnico-responsable/entity-tecnico-responsable.model';
import { selectAuthTecnicoResponsable } from '../../../entity-tecnico-responsable/entity-tecnico-responsable.selectors';
import { selectAllRol, selectRolesPropios } from '../../entity-roles.selectors';
import {
  Rol,
  RolDetailFormInput,
  VinculacionRolActividadInput
} from '../../roles.model';
import { Persona } from '../../../../persona/entity-personas/entity-personas.model';
import { Subscription, combineLatest } from 'rxjs';

@Component({
  selector: 'rpe-entity-vinculo-laboral-form-container',
  templateUrl: './entity-vinculo-laboral-form-container.component.html',
  styleUrls: ['./entity-vinculo-laboral-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityVinculoLaboralFormContainerComponent
  implements OnInit, OnDestroy
{
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  rolesPendientesUsuario: VinculoLaboralSeccionFormInput[] = [];
  rolesPendientesEmpresa: VinculoLaboralSeccionFormInput[] = [];
  rolesAprobados: VinculoLaboralSeccionFormInput[] = [];
  rolesEliminados: VinculoLaboralSeccionFormInput[] = [];

  subscriptions: Subscription[] = [];

  vinculacionRolActividadInput: VinculacionRolActividadInput = undefined;

  constructor(
    public store: Store<State>,
    private storeApp: Store<AppState>,
    private changeDetection: ChangeDetectorRef
  ) {}

  tipoRoles: TipoRol[] = [];

  ngOnInit(): void {
    let auxPersona: Persona;
    let auxTecnicoResponsable: TecnicoResponsable;

    const s1 = this.store
      .pipe(select(selectAuthPersona))
      .subscribe((p) => (auxPersona = p));
    const s2 = this.store
      .pipe(select(selectAuthTecnicoResponsable))
      .subscribe((tr) => (auxTecnicoResponsable = tr));

    // sera usado por cada elemento y rellenara los datos de la empresa dependiendo de la misma
    this.vinculacionRolActividadInput = {
      fecha: new Date(),
      nombre: auxPersona.nombre_completo,
      CJPPU: auxTecnicoResponsable?.cjppu.toString(),
      cedula: auxPersona.documentos_persona[0].numero,
      direccion: auxPersona.direccion_geografica.direccion,
      empresa: undefined,
      rut: undefined,
      title: undefined,
      contentText: undefined,
      contentText2: undefined,
      nombre_rol: undefined,
      rolesActividadConNombre: [],
      actividadesSeleccionadas: undefined,
      submitText: undefined,
      cancelText: undefined,
      cancelColor: undefined,
      submitColor: undefined
    };

    const s3 = this.store
      .pipe(select(selectAllTiposRol))
      .subscribe((listaR) => {
        this.tipoRoles = listaR;
      });
    const s4 = this.store
      .pipe(select(selectRolesPropios))
      .subscribe((roles) => {
        this.generarListas(roles);
      });

    this.subscriptions.push(s1, s2, s3, s4);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  formStatusChanges(status: any) {}

  formValueChanges(rol: any) {
    const s5 = this.store
      .pipe(select(selectRolesPropios))
      .subscribe((roles) => {
        this.generarListas(roles);
      });
    this.subscriptions.push(s5);
  }

  generarListas(listaRoles: Rol[]): void {
    this.rolesPendientesUsuario = [];
    this.rolesPendientesEmpresa = [];
    this.rolesAprobados = [];
    this.rolesEliminados = [];
    // console.log(listaRoles, 'listaRoles');
    listaRoles.forEach((rol) => {
      this.crearVinculo(rol);
    });
    this.changeDetection.detectChanges();
  }

  convertirRolARolDetail(rol: Rol): RolDetailFormInput {
    let salida: RolDetailFormInput;

    // TODO este metodo se debe mejorar
    const s6 = this.store
      .pipe(select(selectAllEntidadesProductiva))
      .subscribe((listaEP) => {
        // console.log(listaEP, 'listaEP', rol.entidad_productiva_id);
        const auxEP = listaEP.find(
          (ep) =>
            // console.log(
            //   ep.id,
            //   rol.entidad_productiva_id,
            //   ep.id == rol.entidad_productiva_id
            // );

            ep.id == rol.entidad_productiva_id
        );
        // console.log(auxEP, 'auxEP');
        if (auxEP != undefined && auxEP.persona_juridica_id != null) {
          this.store
            .pipe(select(selectAllPersonasJuridica))
            .subscribe((listaPJ) => {
              const auxPJ: PersonasJuridica = listaPJ.find(
                (pj) => pj.id === auxEP.persona_juridica_id
              );
              // console.log("this.tipoRoles",this.tipoRoles)
              const auxTR: TipoRol = this.tipoRoles.find(
                (tR) => tR.id == rol.tipo_rol_id
              );
              salida = {
                persona_jurica_denominacion_social: auxPJ.denominacion_social,
                persona_juridica_nombre_fantasia: auxPJ.nombre_fantasia,
                persona_juridica_rut: auxPJ.rut,
                rol_tipo_rol_id_nombre: auxTR?.nombre,
                persona_nombre_completo: null,
                persona_documento_persona_numero: null,
                esPersona: false,
                rol: rol
              };
            });
        } else if (auxEP != undefined && auxEP.persona_fisica_id != null) {
          this.store
            .pipe(select(selectAllPersonasFisica))
            .subscribe((listaPF) => {
              const auxPF: PersonasFisica = listaPF.find(
                (pf) => pf.id == auxEP.persona_fisica_id
              );
              this.store.pipe(select(selectAllPersonas)).subscribe((listaP) => {
                const auxP: Persona = listaP.find(
                  (p) => p.id == auxPF.persona_id
                );
                // console.log(auxPF.persona_id, 'auxPF.persona_id', auxP, listaP);

                const auxTR: TipoRol = this.tipoRoles.find(
                  (tR) => tR.id == rol.tipo_rol_id
                );
                salida = {
                  persona_jurica_denominacion_social: null,
                  persona_juridica_nombre_fantasia: null,
                  persona_juridica_rut: null,
                  rol_tipo_rol_id_nombre: auxTR?.nombre,
                  persona_nombre_completo: auxP?.nombre_completo,
                  persona_documento_persona_numero:
                    auxP?.documentos_persona[0]?.numero, // se asume que el primer dato es el documento que identifica
                  esPersona: true,
                  rol: rol
                };
              });
            });
        }
      });
    this.subscriptions.push(s6);

    return salida;
  }

  // se crean los vinculos y se les asigna los botones visibles
  // cada vinculo se agrega a su correspondiente lista
  crearVinculo(rol: Rol) {
    // console.log(rol, 'crearvinculo');
    const esPendienteUsuario =
      rol.fecha_baja == null &&
      rol.vinculo_aprobado_entidad_productiva &&
      !rol.vinculo_aprobado_rol;
    const esPendienteEmpresa =
      rol.fecha_baja == null &&
      !rol.vinculo_aprobado_entidad_productiva &&
      rol.vinculo_aprobado_rol;
    const esAprobado =
      rol.fecha_baja == null &&
      rol.vinculo_aprobado_entidad_productiva &&
      rol.vinculo_aprobado_rol;
    const esEliminado = rol.fecha_baja != null;

    const verBotonRechazar: boolean = esPendienteUsuario;
    // En caso de que sea el tipo_rol igual a Técnico Responsable acreditado 6 o muestreador 7 se muestra un botón de aceptar
    const verBotonConfirmar: boolean =
      esPendienteUsuario &&
      (rol.tipo_rol_id == 6 ||
        rol.tipo_rol_id == 3 ||
        rol.tipo_rol_id == 5 ||
        rol.tipo_rol_id == 8 ||
        rol.tipo_rol_id == 7 ||
        rol.tipo_rol_id == 4);
    // En caso de que sea el tipo_rol igual a Técnico Responsable se muestra un botón de seleccionar actividades
    // const verBotonSeleccionarActividad: boolean =
    //   esPendienteUsuario && rol.tipo_rol_id == 5; // tecnicoResonsable
    const verBotonDesvincularse: boolean = esAprobado;

    const auxRolDetailFormInput = this.convertirRolARolDetail(rol);
    const auxVinculacionRolActividadInput: VinculacionRolActividadInput = {
      ...this.vinculacionRolActividadInput,
      empresa: auxRolDetailFormInput.persona_jurica_denominacion_social
        ? auxRolDetailFormInput.persona_jurica_denominacion_social
        : auxRolDetailFormInput.persona_nombre_completo,
      rut: auxRolDetailFormInput.persona_juridica_rut
    };

    const auxVinculo: VinculoLaboralSeccionFormInput = {
      vinculacionRolActividadInput: auxVinculacionRolActividadInput,
      rolDetailFormInput: auxRolDetailFormInput,
      verBotonRechazar: verBotonRechazar,
      verBotonConfirmar: verBotonConfirmar,
      verBotonDesvincularse: verBotonDesvincularse
    };
    if (esPendienteUsuario) {
      this.rolesPendientesUsuario.push(auxVinculo);
    } else if (esPendienteEmpresa) {
      this.rolesPendientesEmpresa.push(auxVinculo);
    } else if (esAprobado) {
      this.rolesAprobados.push(auxVinculo);
    } else if (esEliminado) {
      this.rolesEliminados.push(auxVinculo);
    }
  }
}
